import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { TableCell, TableRow } from "@mui/material";
import Checkbox from "../../form/controls/Checkbox";
import { Typography } from "../../pages/create/styles/planExportDialog";
import DateField from "../../form/controls/DateField";
import {
  ORDER_CHECKED_PROPERTY,
  ORDER_END_DATE_PROPERTY,
  ORDER_START_DATE_PROPERTY
} from "../../../business/models/Order/orderConstants";
import { getPropertyTextFromApiData } from "../../../business/models/Order/orderSelectors";

const CopyOrderItem = ({
  orderId,
  marathonOrderId,
  checked,
  description,
  currencySupplierSymbol,
  netTotal,
  orderStartDate,
  orderStartDateErrorText,
  orderEndDate,
  orderEndDateErrorText,
  handleValueChange
}) => {
  const title = useSelector(state =>
    getPropertyTextFromApiData(state, { name: "titleId", orderId })
  );
  return (
    <>
      <TableRow key={`tablerow-${marathonOrderId}`}>
        <TableCell sx={{ padding: 0, width: 2 }}>
          <Checkbox
            onChange={value =>
              handleValueChange(marathonOrderId, value, ORDER_CHECKED_PROPERTY)
            }
            id={`checkboxOrder-${marathonOrderId}`}
            value={checked}
            color="success"
          />
        </TableCell>
        <TableCell sx={{ padding: 0 }}>
          <Typography>{`${marathonOrderId} | ${description} | ${title} | ${currencySupplierSymbol} ${netTotal}`}</Typography>
        </TableCell>
        <TableCell sx={{ padding: 0 }}>
          <DateField
            component="date"
            id={`startDate-${marathonOrderId}`}
            value={orderStartDate}
            onChange={value =>
              handleValueChange(
                marathonOrderId,
                value,
                ORDER_START_DATE_PROPERTY
              )
            }
            disabled={!checked}
            errors={[orderStartDateErrorText]}
            displayErrors={orderStartDateErrorText.length > 0}
          ></DateField>
        </TableCell>
        <TableCell sx={{ padding: 0.5 }}>
          <DateField
            component="date"
            id={`endDate-${marathonOrderId}`}
            value={orderEndDate}
            onChange={value =>
              handleValueChange(marathonOrderId, value, ORDER_END_DATE_PROPERTY)
            }
            disabled={!checked}
            errors={[orderEndDateErrorText]}
            displayErrors={orderEndDateErrorText.length > 0}
          ></DateField>
        </TableCell>
      </TableRow>
    </>
  );
};

CopyOrderItem.propTypes = {
  orderId: PropTypes.number.isRequired,
  marathonOrderId: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  currencySupplierSymbol: PropTypes.string.isRequired,
  netTotal: PropTypes.string.isRequired,
  orderStartDate: PropTypes.string.isRequired,
  orderStartDateErrorText: PropTypes.string.isRequired,
  orderEndDate: PropTypes.string.isRequired,
  orderEndDateErrorText: PropTypes.string.isRequired,
  handleValueChange: PropTypes.func.isRequired
};

export default CopyOrderItem;
